(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.KanjiVariantFilter) return;

  const FILTER_OPTION_SLUG = 'fit-hoodie';
  let scheduled = false;

  function getVariants(picker) {
    const json = picker.querySelector('script[data-variants]');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent || '[]');
    } catch (error) {
      console.warn('[Kanji] No se pudieron leer las variantes.', error);
      return [];
    }
  }

  function optionIndex(wrapper) {
    const match = String(wrapper.dataset.optionIndex || '').match(/\d+/);
    return match ? Number(match[0]) - 1 : -1;
  }

  function getWrappers(picker) {
    return Array.from(
      picker.querySelectorAll('.variant-input-wrapper[data-option-index]')
    )
      .filter((wrapper) => optionIndex(wrapper) >= 0)
      .sort((a, b) => optionIndex(a) - optionIndex(b));
  }

  function getValues(wrapper) {
    const radios = Array.from(
      wrapper.querySelectorAll(
        'input[type="radio"][data-option-value]'
      )
    );

    if (radios.length) {
      return radios.map((input) => ({
        value: input.value,
        control: input,
        container:
          input.closest('li') ||
          input.closest('magnet-element') ||
          input.parentElement,
        type: 'radio'
      }));
    }

    const select = wrapper.querySelector('select');
    if (!select) return [];

    return Array.from(select.options).map((option) => ({
      value: option.value,
      control: option,
      container: option,
      type: 'option',
      select
    }));
  }

  function setVisible(item, visible) {
    if (item.type === 'radio') {
      if (!item.container) return;

      if (!visible) {
        if (!item.container.hidden) {
          item.container.dataset.kanjiVariantHidden = 'true';
          item.container.hidden = true;
        }
      } else if (
        item.container.dataset.kanjiVariantHidden === 'true'
      ) {
        item.container.hidden = false;
        delete item.container.dataset.kanjiVariantHidden;
      }

      return;
    }

    if (!visible) {
      if (!item.control.hidden) {
        item.control.dataset.kanjiVariantHidden = 'true';
        item.control.hidden = true;
      }

      if (!item.control.disabled) {
        item.control.dataset.kanjiVariantDisabled = 'true';
        item.control.disabled = true;
      }

      return;
    }

    if (
      item.control.dataset.kanjiVariantHidden === 'true'
    ) {
      item.control.hidden = false;
      delete item.control.dataset.kanjiVariantHidden;
    }

    if (
      item.control.dataset.kanjiVariantDisabled === 'true'
    ) {
      item.control.disabled = false;
      delete item.control.dataset.kanjiVariantDisabled;
    }
  }

  function choose(item) {
    if (item.type === 'radio') {
      item.control.click();
      return;
    }

    if (item.select.value !== item.value) {
      item.select.value = item.value;

      item.select.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  function selectedValue(wrapper) {
    const radio = wrapper.querySelector(
      'input[type="radio"][data-option-value]:checked'
    );

    if (radio) return radio.value;

    const select = wrapper.querySelector('select');

    return select ? select.value : null;
  }

  function variantMatches(
    variant,
    constraints,
    position,
    candidate
  ) {
    if (!Array.isArray(variant.options)) return false;

    if (variant.options[position] !== candidate) {
      return false;
    }

    for (const [index, value] of constraints) {
      if (value == null) continue;

      if (variant.options[index] !== value) {
        return false;
      }
    }

    return true;
  }

  function getCandidateState(
    variants,
    constraints,
    position,
    candidate
  ) {
    let exists = false;
    let available = false;

    for (const variant of variants) {
      if (
        !variantMatches(
          variant,
          constraints,
          position,
          candidate
        )
      ) {
        continue;
      }

      exists = true;

      /*
       * Shopify considera variant.available = true
       * cuando esa variante puede comprarse.
       */
      if (variant.available === true) {
        available = true;
        break;
      }
    }

    return {
      exists,
      available
    };
  }

  function filterPicker(picker) {
    if (!picker.isConnected) return;

    const wrappers = getWrappers(picker);

    /*
     * Buscamos Fit Hoodie por nombre/slug.
     * Ya NO importa si es opción 1, 2 o 3.
     */
    const fitWrapper = wrappers.find(
      (wrapper) =>
        wrapper.dataset.optionSlug ===
        FILTER_OPTION_SLUG
    );

    if (!fitWrapper || wrappers.length < 2) {
      return;
    }

    const variants = getVariants(picker);

    if (!variants.length) return;

    const fitPosition = optionIndex(fitWrapper);
    const fitValue = selectedValue(fitWrapper);

    if (
      fitPosition < 0 ||
      fitValue == null
    ) {
      return;
    }

    /*
     * Fit Hoodie funciona como restricción principal.
     */
    const constraints = new Map([
      [fitPosition, fitValue]
    ]);

    /*
     * Procesamos todas las demás opciones
     * manteniendo su orden real en Shopify.
     */
    const dependentWrappers = wrappers.filter(
      (wrapper) => wrapper !== fitWrapper
    );

    for (const wrapper of dependentWrappers) {
      const position = optionIndex(wrapper);
      const currentValue = selectedValue(wrapper);
      const items = getValues(wrapper);

      const validItems = [];

      for (const item of items) {
        const state = getCandidateState(
          variants,
          constraints,
          position,
          item.value
        );

        /*
         * Si la combinación no existe,
         * desaparece completamente.
         */
        setVisible(
          item,
          state.exists
        );

        if (state.exists) {
          validItems.push({
            ...item,
            available: state.available
          });
        }
      }

      /*
       * Si el valor actualmente seleccionado
       * ya no existe con este Fit,
       * debemos corregirlo.
       */
      const currentStillExists =
        validItems.some(
          (item) =>
            item.value === currentValue
        );

      if (
        !currentStillExists &&
        validItems.length
      ) {
        /*
         * Primero buscamos una opción
         * que conduzca a una variante disponible.
         *
         * Si todas están agotadas,
         * usamos igualmente la primera existente.
         */
        const nextItem =
          validItems.find(
            (item) => item.available
          ) ||
          validItems[0];

        choose(nextItem);

        /*
         * Concept procesará el cambio y
         * volveremos a calcular después.
         */
        return;
      }

      constraints.set(
        position,
        currentValue
      );
    }
  }

  function filterAll() {
    document
      .querySelectorAll('variant-picker')
      .forEach(filterPicker);
  }

  function scheduleFilter() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      filterAll();
    });
  }

  /*
   * Dejamos que Concept procese primero
   * el cambio de variante.
   */
  document.addEventListener(
    'change',
    (event) => {
      const picker =
        event.target.closest?.(
          'variant-picker'
        );

      if (!picker) return;

      if (
        !picker.querySelector(
          `[data-option-slug="${FILTER_OPTION_SLUG}"]`
        )
      ) {
        return;
      }

      setTimeout(
        scheduleFilter,
        0
      );

      setTimeout(
        scheduleFilter,
        80
      );
    }
  );

  /*
   * Concept puede reemplazar partes del
   * selector al cambiar variantes.
   *
   * Solo reaccionamos a cambios relacionados
   * con variant-picker para evitar trabajo innecesario.
   */
  const observer =
    new MutationObserver(
      (mutations) => {
        for (
          const mutation of mutations
        ) {
          const target =
            mutation.target;

          if (
            target instanceof Element &&
            (
              target.matches(
                'variant-picker'
              ) ||
              target.closest(
                'variant-picker'
              )
            )
          ) {
            scheduleFilter();
            return;
          }

          for (
            const node of
            mutation.addedNodes
          ) {
            if (
              !(node instanceof Element)
            ) {
              continue;
            }

            if (
              node.matches(
                'variant-picker'
              ) ||
              node.querySelector(
                'variant-picker'
              )
            ) {
              scheduleFilter();
              return;
            }
          }
        }
      }
    );

  function init() {
    filterAll();

    observer.observe(
      document.body ||
        document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }

  window.KanjiVariantFilter = {
    refresh: scheduleFilter
  };
})();
  } catch(e) { console.error(e); }
})();

})();
